import { UiTableHeadCells } from './UiTableHeader.component';
import { UiTableRowItem } from './UiTableRowItem.component';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { getColor } from '@api/business/treatmentHook/Treatment.helper';
import { TableDataItem } from '@api/business/treatmentHook/useForecastTool';
import { PlcTextListLoader } from '@components/Loaders/PlcTextLoader.component';
import { Text } from '@components/Text/Text.component';
import { PlcColor } from '@styles/colors';
import { formatDateToFullTextWithToday } from '@utils/date';

type UiTableRowProps = {
  data: TableDataItem;
  setHoveredIndex: (value: number) => void;
  hoveredIndex: number | undefined;
};

const UiTableRow: FC<UiTableRowProps> = ({ data, setHoveredIndex, hoveredIndex }) => {
  const { t } = useTranslation();
  return (
    <tr>
      <th className="table-left-item" scope="row">
        <div className="flex-table-content-item-header">
          <Text tag="span" variant="h6">
            {formatDateToFullTextWithToday(data.date, t('common.today'), false)}
          </Text>
        </div>
      </th>
      {UiTableHeadCells.map((hc, index) => {
        const item = data[hc.id];
        return (
          <td
            align="right"
            key={item ? item.date.toISOString() : index}
            onMouseEnter={() => setHoveredIndex(index)}
            style={{ backgroundColor: hoveredIndex === index ? PlcColor.GREY_CLOUD_LIGHT : PlcColor.WHITE }}
          >
            {item ? (
              <UiTableRowItem color={getColor(item.score).label} reason={item.reason} />
            ) : (
              <div className="flex-table-content-item-empty">
                <Text i18nKey="common.unknown" tag="span" variant="h6" />
              </div>
            )}
          </td>
        );
      })}
    </tr>
  );
};

const UiTableRowLoader: FC<{ uniquekey: string }> = ({ uniquekey }) => {
  return (
    <tr>
      {}
      <th className="table-left-item" scope="row">
        <div className="flex-table-content-item-header">
          <PlcTextListLoader fixedWidth textProps={[{ variant: 'h6', width: 80 }]} uniqueKey={uniquekey} />
        </div>
      </th>
      {UiTableHeadCells.map((_data) => {
        return (
          <td align="right" key={_data.id}>
            <div className="flex-table-content-item-empty">
              <PlcTextListLoader fixedWidth textProps={[{ variant: 'h6', width: 25 }]} uniqueKey={uniquekey} />
            </div>
          </td>
        );
      })}
    </tr>
  );
};

export { UiTableRow, UiTableRowLoader };
